import Vue from 'vue';
import template from './login-dialog.html';
import { DialogBox, dialogDefaultConfiguration, dialogDefaultMethods } from "./dialog-box";
import { isEmailAddress } from "../helpers/emails.mjs";
import { ERROR_INVALID_EMAIL, ERROR_NO_EMAIL, ERROR_NO_PASSWORD } from "../lang";
import { ResetPasswordDialog } from "./reset-password.mjs";
import { PostcodeSearchDialog } from "./postcode-search.mjs";
import apiService from "../api.mjs";

const tagName = 'dialog-login';

export const loginDialogDefinition = {
    ...dialogDefaultConfiguration,
    template : template,
    methods  : {
        ...dialogDefaultMethods,
        onEmailEnterKey : function( event ) {
            event.preventDefault();
            if( this.model.email_address.length ) {
                this.$refs[ 'password_input' ].focus();
            }

            return false;
        },
        onPasswordEnterKey : function( event ) {
            event.preventDefault();
            if( this.model.email_address.length && this.model.password.length ) {
                this.model.onLoginButtonClick();
            }

            return false;
        }
    }
};

Vue.component( tagName, loginDialogDefinition );

export class LoginDialog extends DialogBox {

    constructor() {
        super();
        this.email_address  = '';
        this.password       = '';
        this.error_form     = null;
        this.error_email    = null;
        this.error_password = null;

        this.active_request = false;
        this.redirecting    = false;
    }

    getComponentTag() {
        return tagName;
    }

    getComponentData() {
        return {
            error_form    : this.error_form,
            error_email   : this.error_email,
            error_password: this.error_password,
            req_active    : this.active_request,
            redirecting   : this.redirecting
        };
    }

    onSignupLinkClick() {
        this.transitionTo( new PostcodeSearchDialog(), 'to: create account' );
    }

    onResetLinkClick() {
        this.transitionTo( new ResetPasswordDialog(this.email_address), 'to: reset password' );
    }

    onLoginButtonClick() {
        if( this.active_request )
            return;

        // Reset the state initially, and then we can test on these properties.
        this.error_form    = this.error_email = this.error_password = null;
        this.email_address = this.email_address.trim();

        if( !this.email_address ) {
            this.error_email = ERROR_NO_EMAIL;
        } else if( !isEmailAddress( this.email_address ) ) {
            this.error_email = ERROR_INVALID_EMAIL;
        }

        if( !this.password ) {
            this.error_password = ERROR_NO_PASSWORD;
        }

        if( this.error_form || this.error_email || this.error_password )
            return true;

        // Send something?
        apiService.authenticateUser( this.email_address, this.password )
            .then( response => {
                if( !response.authenticated ) {
                    this.error_form = 'Email and/or password not recognised.';
                    return false;
                }
                if( response.next )
                    window.location = response.next;

                //pushEvent( '' );
                this.redirecting = true; // there's a hook that checks this...
                return true;
            })

            .catch( error => {
                console.warn('error', error);
                this.error_form = 'Something went wrong, please try again.';
            })

            .finally( () => {
                // Make sure we _definitely_ cancel the loading state, even if
                // an error gets thrown.
                this.active_request = false;
            })
        ;

        this.active_request = true;
    }

    onBeforeClose()
    {
        return (!this.active_request) || confirm("You're currently trying to log in. Abort?");
    }
}
